// src/components/shared/StatusBadge.jsx
import React from 'react';

const statusColors = {
  0: 'var(--color-idle)',
  1: 'var(--color-online)',
  2: 'var(--color-printing)',
  3: 'var(--color-red)',
};
// const statusLabels = {
//   0: 'Nieaktywny',
//   1: 'Printing',
//   2: 'Idle',
//   3: 'Error'
// };

export default function StatusBadge({ status }) {
  const color = statusColors[status] || 'black';
//   const label = statusLabels[status] || 'Nieznany';

  return (
    <div style={{ color,
        backgroundColor: color,
        width: '1.25rem',
        height: '1.25rem',
        borderRadius: '50%',
        display: 'inline-block',
        // margin: '0 auto'
    }}>
    </div>
  );
}
